import 'fomantic-ui-css/semantic.min.css';
import {initApp} from './Init';

initApp();
